// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"styles_searchBar__3a4V2","container":"styles_container__Qbp9k","logo":"styles_logo___m5Kp","searchContainer":"styles_searchContainer__32VCF"};